import _ from 'lodash';
import Grid from '@mui/material/Grid';
import React, { useState } from 'react';
import { Radio, Typography } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import TuneIcon from '@mui/icons-material/Tune';
import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { makeStyles } from "@material-ui/core/styles";
import { findIndex, map } from "lodash";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const filterByDays = [
    { 'value': 30, 'label': '1 Month' },
    { 'value': 90, 'label': '3 Month' },
    { 'value': 180, 'label': '6 Month' },
    { 'value': 365, 'label': '1 Year' },
    { 'value': 0, 'label': 'All' }
];
const WWAdminBox2 = (props) => {
    const classes = useStyles();
    // State    
    const [selectedDropdownData, setSelectedDropdownData] = useState([filterByDays[0]]);

    const handleOnChange = (itemData) => {
        setSelectedDropdownData([itemData]);
        props.filterByDays(itemData)
    };
    return (
        <Grid container >
            <Grid item xs={12} sx={{ mt: 3, mx: 1, my: 1, background: 'linear-gradient(to right, #fcfcfc 0%,#f5f7ff 43%,#edf0ff 100%);', borderRadius: 5, boxShadow: '3px 3px 5px 1px #dddddd','@media (min-width: 1636px)': {mx: 3} }}>
                <List sx={{ p: 0, m: 0 }}>
                    <ListItem sx={{ p: 0 }} disablePadding secondaryAction={
                        <>
                            {/* <IconButton disabled>
                                <img src={require('../../assets/assignment.png')} width='140px' className={classes.image} />
                            </IconButton> */}
                            <FormControl sx={{width: '55px'}}>
                                <Select
                                    sx={{ borderRadius: 70, border: 'none', mt: 4, '.MuiOutlinedInput-notchedOutline': { border: 0 }, "@media (min-width: 1636px)": {
                                        mt: 8,
                                    }}}
                                    value={[]}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => `${selected.value}`}
                                    MenuProps={MenuProps}
                                    IconComponent={() => (
                                        <IconButton sx={{ position: 'absolute', left: 7, zIndex: -1, borderRadius: 10, fontWeight: "600", color: "primary.main", boxShadow: 0, textTransform: 'inherit', '&:hover': { backgroundColor: 'primary.main', color: '#F5F5F5' } }}>
                                            <TuneIcon  sx={{'@media (min-width: 1636px)': {fontSize: '1.8rem'}}}/>
                                        </IconButton>
                                    )}
                                >
                                    {filterByDays.map((itemData, index) => (
                                        <MenuItem key={`${index}_days`} value={itemData} onClick={() => handleOnChange(itemData)}>
                                            <Radio checked={selectedDropdownData && selectedDropdownData.filter((item) => item.value == itemData.value).length > 0} />
                                            <ListItemText primary={itemData.label} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </>
                    }>
                        <ListItemButton sx={{ borderRadius: 4, p: 4 }}>
                            <ListItemText sx={{ m: 0, px: 0 }}
                                primary={<Typography variant="body2"
                                    sx={{ color: '#5f5600ff', fontWeight: '800', fontSize: '1.8rem','@media (min-width: 1636px)': {fontSize: '2.6rem'} }}>
                                    {props.activeCount}
                                </Typography>}
                                secondary={<Typography
                                    sx={{ color: '#5f5600ff', fontSize: '1rem', fontWeight: '500', '@media (min-width: 1636px)': {fontSize: '1.4rem'}}}>
                                    {props.totCount} {props.text}
                                </Typography>} />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Grid>
        </Grid>
    )
}
const useStyles = makeStyles({
    image: {
      "@media (min-width: 1636px)": {
        width: "14rem",
      },
    },
  });
export default WWAdminBox2;